(function () {
  if (window.__STBgCoverParallaxInit) return;
  window.__STBgCoverParallaxInit = true;

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function effectiveAspectRatio(el) {
    var desktopAr = el.getAttribute('data-bg-parallax-aspect');
    var mobileAr = el.getAttribute('data-bg-parallax-aspect-mobile');
    var useMobile = mqMobile.matches;
    var raw = useMobile && mobileAr ? mobileAr : desktopAr || mobileAr;
    if (!raw) return NaN;
    var ar = parseFloat(raw);
    return Number.isFinite(ar) && ar > 0 ? ar : NaN;
  }

  /**
   * Vertical slack (px) for object-fit: cover + center: how far we can translate before exposing edges.
   * ar = image width / height (Shopify aspect_ratio). cw,ch = clip rect in px.
   */
  function coverVerticalSlackPx(cw, ch, ar) {
    if (!(cw > 0) || !(ch > 0) || !Number.isFinite(ar) || ar <= 0) return 0;
    var displayedH = Math.max(cw / ar, ch);
    return Math.max(0, (displayedH - ch) / 2);
  }

  function updateBgCoverParallax() {
    var roots = document.querySelectorAll('.bg-cover-parallax-root');
    if (!roots.length) return;

    if (mqReduce.matches) {
      roots.forEach(function (el) {
        el.style.setProperty('--bg-cover-parallax-y', '0px');
      });
      return;
    }

    roots.forEach(function (el) {
      var rangePx = parseFloat(el.getAttribute('data-bg-parallax-range') || '120');
      if (!Number.isFinite(rangePx)) rangePx = 120;

      var scaleStr = getComputedStyle(el).getPropertyValue('--bg-cover-parallax-scale').trim();
      var scale = parseFloat(scaleStr);
      if (!Number.isFinite(scale) || scale < 1.01) scale = 1.16;

      var rect = el.getBoundingClientRect();
      var cw = rect.width;
      var ch = rect.height;
      var vh = window.innerHeight || 1;

      var scaleSlack = ((ch * (scale - 1)) / 2) * 0.92;
      var ar = effectiveAspectRatio(el);
      var naturalSlack = coverVerticalSlackPx(cw, ch, ar) * 0.98;
      var slack = naturalSlack + scaleSlack;
      var maxY = Math.min(Math.max(0, rangePx), Math.max(0, slack));

      var mid = rect.top + ch / 2;
      var denom = Math.max(vh * 0.35 + ch * 0.2, 1);
      var norm = (mid - vh / 2) / denom;
      if (norm > 1) norm = 1;
      if (norm < -1) norm = -1;
      var y = -norm * maxY;

      el.style.setProperty('--bg-cover-parallax-y', y.toFixed(2) + 'px');
    });
  }

  var ticking = false;
  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateBgCoverParallax();
      });
    }
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  if (mqReduce.addEventListener) {
    mqReduce.addEventListener('change', updateBgCoverParallax);
  } else if (mqReduce.addListener) {
    mqReduce.addListener(updateBgCoverParallax);
  }
  if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', updateBgCoverParallax);
  } else if (mqMobile.addListener) {
    mqMobile.addListener(updateBgCoverParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBgCoverParallax);
  } else {
    updateBgCoverParallax();
  }
})();
